export default class HiddenReportPartModel {
    specificationTypeId: string;
    hiddenReportParts: { [key: string]: string[] };
}